import type { KhaataEntryType } from '../constants/khaataCategories';
import { normalizeKhaataType } from '../constants/khaataCategories';

export interface Expense {
  id: string;
  date: string;
  userId: string;
  userName: string;
  restId: string;
  /** Derived from the selected category: expense | purchase | asset | liability */
  type: KhaataEntryType;
  category: string;
  /** Denormalized display label for the category (snapshot at save time) */
  categoryLabel?: string;
  description: string;
  amount: number;
  paymentMethod: 'cash' | 'card' | 'upi' | 'bank_transfer' | 'pending';
  /** URL of attached bill (PDF/PNG/JPG/WEBP) stored in GCS */
  billUrl?: string;
  /** Vendor link (purchase/asset) */
  supplierId?: string;
  supplierName?: string;
  /** Invoice / bill reference number */
  invoiceNumber?: string;
  /** Payment due date for credit purchases / liabilities */
  dueDate?: string;
}

export interface ExpenseFilter {
  period: 'daily' | 'weekly' | 'monthly' | 'yearly' | 'custom';
  year: number;
  fromDate?: string; // yyyy-MM-dd
  toDate?: string;   // yyyy-MM-dd
  /** Filter by entry type; omit or 'all' for all types */
  type?: KhaataEntryType | 'all';
  category?: string;
  supplierId?: string;
}

/** Normalize legacy records that predate/mismatch the type field */
export function getExpenseType(expense: Pick<Expense, 'type'>): KhaataEntryType {
  return normalizeKhaataType(expense.type);
}

export function applyExpenseFilters(expenses: Expense[], filter: ExpenseFilter): Expense[] {
  return expenses.filter((e) => {
    const entryType = getExpenseType(e);
    if (filter.type && filter.type !== 'all' && entryType !== filter.type) {
      return false;
    }
    if (filter.category && e.category !== filter.category) {
      return false;
    }
    if (filter.supplierId && e.supplierId !== filter.supplierId) {
      return false;
    }
    return true;
  });
}
